import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ENTITY } from "../constants";
import { getCurrentElement } from "../store/actions";
import { currentElementSelector, elementsDialogSelector } from "../store/selectors";

export function useCurrentElementData(props) {
  const { propertyId } = props;
  const dispatch = useDispatch();
  const timer = useRef(null);

  const { element } = useSelector(currentElementSelector);
  const { isOpen: isElementDialogOpen } = useSelector(elementsDialogSelector());

  const hookEnabled = !!element.id;

  const fetchCurrentElement = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      dispatch(
        getCurrentElement({
          propertyId,
          experienceId: element.experienceId,
          mediaItemId: element.mediaItemId,
          elementId: element.id,
        }),
      );
    }, 300);
  };

  useEffect(() => {
    if (hookEnabled) {
      const listener = ({ detail }) => {
        const { instances } = detail;

        if (instances?.includes?.(element.id) && !isElementDialogOpen) {
          fetchCurrentElement();
        }
      };

      const entities = [ENTITY.ELEMENT, ENTITY.CONTENT_ELEMENT];

      entities.forEach((entity) => document.addEventListener(entity, listener));
      return () => entities.forEach((entity) => document.removeEventListener(entity, listener));
    }
  }, [element, hookEnabled]);
}
